export enum GlobalAppDataKey {
  VerificationMetadata = 'VerificationMetadata',
  OrgSettings = 'OrgSettings',
  TaxonomyGroups = 'TaxonomyGroups',
  Taxonomies = 'Taxonomies'
}
